import preval from "preval.macro";

const buildTimestamp = preval`module.exports = new Date().getTime();`;
const buildVersion = process.env?.REACT_APP_VERSION;

export default {
  version: buildVersion,
  timestamp: buildTimestamp,
};
